const Contact = () => {
  return (
    <>
      <h1>Contact</h1>
      <p>dhcjkhbvjdsbvjbdsjvbdfjvbjfbvkjf</p>
    </>
  );
};
export default Contact;
